export const eventTypes = {
  sizes: {
    base: "sizes",
    options: {
      normal: "normal",
      small: "small",
      large: "large",
      huge: "huge",
    },
  },
  quote: "quote",
  undo: "undo",
  redo: "redo",
  bold: "bold",
  italic: "italic",
  underline: "underline",
  color: {
    base: "colors",
    options: { text: "color", background: "background" },
  },
  code: "code",
  image: "image",
  link: "link",
  list: "list",
  listNumber: "listNumber",
  listBullet: "listBullet",
  align: {
    base: "align",
    options: { left: "alignLeft", center: "alignCenter", right: "alignRight" },
  },
  indent: "indent",
  indentDecrease: "indentDecrease",
  removeFormat: "removeFormat",
  strike: "strike",
  attachFile: "attachFile",
  insertPhoto: "insertPhoto",
  fontSize: "fontSize",
  fontFamily: "fontFamily",
  emoji: "emoji",
  drive: "drive",
  lockClock: "lockClock",
  insertSignature: "insertSignature",
};
export const toolbarComponentType = {
  styling: "styling",
  divider: "divider",
  component: "component",
};

export const pluginList = [
  {
    type: toolbarComponentType["styling"],
    icon: "Styling",
    id: "4bc66ea9-2e35-4a7b-a674-be7e4ee163c5",
    label: "Formatting options",
    options: [
      {
        name: eventTypes["undo"],
        type: toolbarComponentType["component"],
        icon: "Undo",
        label: "Undo",
        id: "29cf5eb3-37cd-482f-9a15-c358faf19cc2",
      },
      {
        name: eventTypes["redo"],
        type: toolbarComponentType["component"],
        icon: "Redo",
        label: "Redo",
        id: "8744f7ab-5818-46ce-9417-2fec87123afe",
      },
      {
        type: toolbarComponentType["divider"],
        id: "ed0104fd-3507-43f6-80c1-813fbdf04479",
      },
      {
        name: eventTypes["fontFamily"],
        type: toolbarComponentType["component"],
        id: "1c12d7e2-aa6a-42b4-b25c-b55fe3bcf524",
        label: "Font",
      },
      {
        type: toolbarComponentType["divider"],
        id: "d0f67d01-0731-411a-b448-e1dca47014f4",
      },
      {
        name: eventTypes["fontSize"],
        type: toolbarComponentType["component"],
        id: "82e31b62-5441-4052-887c-faa02d0b7075",
        label: "Size",
      },
      {
        type: toolbarComponentType["divider"],
        id: "2e3558e4-3ad4-422b-8502-ea3c58fb8c2e",
      },
      {
        name: eventTypes["bold"],
        type: toolbarComponentType["component"],
        icon: "Bold",
        label: "Bold",
        id: "ac2b5b54-7323-44a4-bc6d-8bae6e48efe2",
      },
      {
        name: eventTypes["italic"],
        type: toolbarComponentType["component"],
        icon: "Italic",
        label: "Italic",
        id: "6a927c2a-2230-4dc7-af71-47fbe9fb784d",
      },
      {
        name: eventTypes["underline"],
        type: toolbarComponentType["component"],
        icon: "Underline",
        label: "Underline",
        id: "f07b3a6f-ffaa-4153-beae-79a36acb6a08",
      },
      {
        name: eventTypes["color"].base,
        type: toolbarComponentType["component"],
        icon: "Text color",
        label: "Text color",
        id: "e14ec25f-3dd3-4ed5-b33a-a033684d248b",
      },
      {
        type: toolbarComponentType["divider"],
        id: "93e60297-206f-4f31-bc29-11daff2052bd",
      },
      {
        name: eventTypes.align.base,
        type: toolbarComponentType["component"],
        id: "30da93ea-efa6-4642-bfa5-28fd4dc9c5b3",
        label: "Align",
        collapse: true,
      },
      {
        type: toolbarComponentType["divider"],
        id: "9bad0563-6118-4855-9286-402bf98e00ad",
        hideOnCollapse: true,
      },
      {
        name: eventTypes["listNumber"],
        type: toolbarComponentType["component"],
        icon: "OrderedList",
        label: "Ordered list",
        id: "d37865e1-ff54-4118-a5cc-fa147d222471",
        collapse: true,
      },
      {
        name: eventTypes["listBullet"],
        type: toolbarComponentType["component"],
        icon: "UnOrderedList",
        label: "Unordered list",
        id: "ed77e7c9-b89c-41c5-a749-e68ea0b30497",
        collapse: true,
      },
      {
        type: toolbarComponentType["divider"],
        id: "e5ecd77b-44cc-42fe-badb-48cadf3ddfb1",
        hideOnCollapse: true,
      },
      {
        name: eventTypes["indentDecrease"],
        type: toolbarComponentType["component"],
        icon: "IndentLess",
        label: "Decrease indent",
        id: "2dc6a5e4-b1b5-47d1-ac2f-5d0becb02d33",
        collapse: true,
      },
      {
        name: eventTypes["indent"],
        type: toolbarComponentType["component"],
        icon: "IndentMore",
        label: "Increase indent",
        id: "6903a3d1-a83f-4bc6-9bd9-f673feffe84f",
        collapse: true,
      },
    ],
  },
  {
    type: "component",
    name: eventTypes["attachFile"],
    icon: "Attach",
    label: "Attach file",
    id: "f43a284e-113e-4095-b001-9d00a1dddc4c",
  },
  {
    type: toolbarComponentType["component"],
    name: eventTypes["link"],
    icon: "Link",
    label: "Insert link",
    id: "580db61e-7939-4efe-914c-304b271998ec",
  },
  {
    type: toolbarComponentType["component"],
    name: eventTypes["emoji"],
    icon: "Emoji",
    id: "e1f2c6d1-emoji",
  },
  // {
  //   type: toolbarComponentType["component"],
  //   name: eventTypes["drive"],
  //   icon: "GoogleDrive",
  //   id: "a9c4b1e2-drive",
  // },
  {
    type: "component",
    name: eventTypes["insertPhoto"],
    icon: "InsertImage",
    label: "Insert photo",
    id: "d032ba91-3e78-4ed5-8561-insertPhoto",
  },
  {
    type: "component",
    name: eventTypes["lockClock"],
    icon: "LockClock",
    id: "d032ba91-3e78-4ed5-8561-lockClock",
  },
  {
    type: "component",
    name: eventTypes["insertSignature"],
    icon: "Signature",
    label: "Insert signature",
    id: "d032ba91-3e78-4ed5-8561-lockClock",
  },
];
